module.exports = __webpack_public_path__ + "img/55ad107a-888a-4809-8f0e-a8e5d42ae10d.10840e0a.webp";